import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {AddressBookItem, AddressBooksState} from './types';
import {directDownloadLK} from "@/utils/download-helper";

export const actions: ActionTree<AddressBooksState, RootState> = {
    getAddressBooks: ({commit, dispatch}, data) => {
        return new Promise((resolve, reject) => {
            axios({url: '/lk-api/address-book/group', params: data})
                .then(resp => {
                    commit('setAddressBooks', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    getAddressBookItem: ({commit, dispatch}, id: number) => {
        return new Promise((resolve, reject) => {
            axios({url: `/lk-api/address-book/group?groupId=${id}`})
                .then((resp: any) => {
                    let addressBookItem = resp.data;
                    addressBookItem.groupId = id;
                    commit('setAddressBookItem', addressBookItem);
                    resolve(addressBookItem)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    saveAddressBook: ({commit, dispatch}, data: AddressBookItem) => {
        return new Promise((resolve, reject) => {
            axios({
                method: data.groupId ? 'put' : 'post',
                url: '/lk-api/address-book/group',
                data: data
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    deleteAddressBook: ({commit, dispatch}, data: AddressBookItem) => {
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: '/lk-api/address-book/group',
                data: data
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    exportAddressBookContacts: async ({commit, dispatch}, addressBookId: number) => {
        await directDownloadLK(`/lk-api/address-book/address-book-contact/export?groupId=${addressBookId}`)
    },
    importAddressBookContacts: ({commit, dispatch}, data: any) => {
        return new Promise(async (resolve, reject) => {
            axios({
                method: 'put',
                url: `/lk-api/address-book/address-book-contact/import`,
                data: data
            })
                .then((resp: any) => {
                    resolve(resp?.data)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    preImport: ({commit, dispatch}, data: any) => {
        return new Promise(async (resolve, reject) => {
            axios({
                method: 'post',
                url: `/lk-api/file/pre-import`,
                data: data
            })
                .then((resp: any) => {
                    resolve(resp.data.fieldSequence)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    getAddressBookContacts: ({commit, dispatch}, data: any) => {
        return new Promise((resolve, reject) => {
            axios({url: `/lk-api/address-book/address-book-contact`, params: data })
                .then((resp: any) => {
                    if (data.page_number > 1) {
                        commit('setAddressBookContactsMore', resp.data.contacts);
                    } else {
                        commit('setAddressBookContacts', resp.data.contacts);
                    }
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    saveAddressBookContact: ({commit, dispatch}, data: any) => {
        return new Promise((resolve, reject) => {
            axios({
                method: data.id ? 'put' : 'post',
                url: `/lk-api/address-book/address-book-contact`,
                data: data
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    deleteAddressBookContact: ({commit, dispatch}, data: any) => {
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: `/lk-api/address-book/address-book-contact`,
                data: data
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    copyAddressBookContacts: ({commit, dispatch}, data: any) => {
        return new Promise((resolve, reject) => {
            axios({
                method: 'put',
                url: `/lk-api/address-book/address-book-contact/copy`,
                data: data
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    moveAddressBookContacts: ({commit, dispatch}, data: any) => {
        return new Promise((resolve, reject) => {
            axios({
                method: 'put',
                url: `/lk-api/address-book/address-book-contact/move`,
                data: data
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
    checkAddressBookContactDuplicates: ({commit, dispatch}, data: any) => {
        return axios({
                method: 'post',
                url: '/lk-api/address-book/address-book-contact/duplicates',
                data: data
            })
    },
    checkAddressBookContacts: ({commit, dispatch}, id: number) => {
        return new Promise(async (resolve, reject) => {
            axios({
                method: 'post',
                url: `/lk-api/address-book/address-book-contacts/check?groupId=${id}`,
            })
                .then((resp: any) => {
                    resolve(resp?.data)
                })
                .catch((err: any) => {
                    reject(err)
                })
        })
    },
};
